let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("h0tgb")).then(() => parcelRequire('9Qguw'));